module.exports = __webpack_public_path__ + "img/cat-01-ac.72c20165.svg";